<script lang="ts" setup>
import AlternateMarquee from '@/components/AlternateMarquee.vue';
</script>

<template>
  <section class="page-home-information pb-100 <md:pb-40">
    <div class="mx-auto max-w-1200 flex flex-nowrap gap-x-95 <md:flex-wrap <md:gap-x-0 <md:gap-y-24 <sm:px-16 <xl:px-24">
      <div class="w-540 flex-shrink-0 pt-112 <md:w-full <md:pt-24">
        <h2 class="my-0 text-nowrap text-46 text-#292D33 font-800 leading-60 <md:whitespace-normal <md:text-28 <md:leading-36">
          {{ $t('home.information.content1.title1') }}
          <AlternateMarquee>{{ $t('home.information.content1.title2') }}</AlternateMarquee>
        </h2>

        <p class="mb-0 mt-30 text-20 text-#9497A1 font-400 leading-1.5em <md:text-14">
          {{ $t('home.information.content1.desc') }}
        </p>

        <div class="mt-30 flex justify-between <md:mt-24 <md:flex-col">
          <RouterLink to="/cooperation" class="h-54 w-190 flex-center rounded-6 bg-#1281FF text-16 text-white font-700 leading-24 no-underline shadow-[0px_12px_30px_rgba(24,92,255,0.18)] <md:w-full">
            {{ $t('home.information.content1.button') }}
          </RouterLink>
        </div>
      </div>

      <div class="<md:w-full">
        <img data-src="@/assets/home/banner2.png" alt="" class="lazyload block h-590 <md:h-auto <md:max-h-320 <md:w-full <md:object-contain">
      </div>
    </div>

    <div class="mx-auto mt-60 max-w-1602 flex flex-nowrap gap-x-95 <md:mt-32 <md:flex-wrap <md:gap-x-0 <md:gap-y-24 <sm:px-16 <xl:px-24">
      <div class="<md:order-2 <md:w-full">
        <img data-src="@/assets/home/banner3.png" alt="" class="lazyload block h-590 <md:h-auto <md:max-h-320 <md:w-full <md:object-contain">
      </div>

      <div class="w-540 flex-shrink-0 pt-112 <md:order-1 <md:w-full <md:pt-24">
        <h2 class="my-0 text-nowrap text-46 text-#292D33 font-800 leading-60 <md:whitespace-normal <md:text-28 <md:leading-36">
          {{ $t('home.information.content2.title1') }}
          <AlternateMarquee>{{ $t('home.information.content2.title2') }}</AlternateMarquee>
        </h2>

        <p class="mb-0 mt-30 text-20 text-#9497A1 font-400 leading-1.5em <md:text-14">
          {{ $t('home.information.content2.desc') }}
        </p>

        <div class="mt-30 flex justify-between <md:mt-24 <md:flex-col">
          <RouterLink to="/projects" class="h-54 w-190 flex-center rounded-6 bg-#1281FF text-16 text-white font-700 leading-24 no-underline shadow-[0px_12px_30px_rgba(24,92,255,0.18)] <md:w-full">
            {{ $t('home.information.content2.button') }}
          </RouterLink>
        </div>
      </div>
    </div>

    <div class="mx-auto mt-60 max-w-1200 flex flex-nowrap gap-x-95 <md:mt-32 <md:flex-wrap <md:gap-x-0 <md:gap-y-24 <sm:px-16 <xl:px-24">
      <div class="w-540 flex-shrink-0 pt-112 <md:w-full <md:pt-24">
        <h2 class="my-0 text-nowrap text-46 text-#292D33 font-800 leading-60 <md:whitespace-normal <md:text-28 <md:leading-36">
          {{ $t('home.information.content3.title1') }}
          <AlternateMarquee>{{ $t('home.information.content3.title2') }}</AlternateMarquee>
        </h2>

        <p class="mb-0 mt-30 text-20 text-#9497A1 font-400 leading-1.5em <md:text-14">
          {{ $t('home.information.content3.desc') }}
        </p>

        <div class="mt-30 flex justify-between <md:mt-24 <md:flex-col">
          <a href="https://community.openatom.cn/" class="h-54 w-190 flex-center rounded-6 bg-#1281FF text-16 text-white font-700 leading-24 no-underline shadow-[0px_12px_30px_rgba(24,92,255,0.18)] <md:w-full" target="_blank">
            {{ $t('home.information.content3.button') }}
          </a>
        </div>
      </div>

      <div class="<md:w-full">
        <img data-src="@/assets/home/banner4.png" alt="" class="lazyload block h-470 <md:h-auto <md:max-h-320 <md:w-full <md:object-contain">
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
</style>
